import { useEffect, useState } from 'react';

import { type FeaturesResponse, idpApi } from '../services/idp-api';

const defaultFeatures: FeaturesResponse = { google: false };

let cachedFeatures: FeaturesResponse | null = null;
let fetchPromise: Promise<FeaturesResponse> | null = null;

function fetchFeatures(): Promise<FeaturesResponse> {
  if (!fetchPromise) {
    fetchPromise = idpApi.getFeatures().catch(() => defaultFeatures);
  }
  return fetchPromise;
}

export function useFeatures(): FeaturesResponse {
  const [features, setFeatures] = useState<FeaturesResponse>(cachedFeatures ?? defaultFeatures);

  useEffect(() => {
    if (cachedFeatures) {
      return;
    }

    void fetchFeatures().then((result) => {
      cachedFeatures = result;
      setFeatures(result);
    });
  }, []);

  return features;
}
